import firebase from 'firebase/compat/app'

import 'firebase/compat/auth'
import 'firebase/compat/firestore'
import 'firebase/compat/storage'
import 'firebase/compat/functions'

// Your web app's Firebase configuration
// Use config-dev for deve environment configuration
import firebaseConfig from './config'

// Initialize Firebase
const connection = firebase.initializeApp(firebaseConfig)

export const db = connection.firestore()
export const auth = connection.auth()
export const storage = connection.storage().ref()

export default connection
